import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@tanstack/react-query'
import clsx from 'clsx'
import { useStyles } from '../styles'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import { postNamedQuery } from '../../../../../service'
import SydButton from '../../../../commonDesign/Button'

export const DocumentDetailPreviewBlock = ({
  document
}) => {
  const classes = useStyles()
  const [fullscreen, setFullScreen] = React.useState(false)

  const getDocumentUrl = async () => {
    if (document.variantId) {
      return postNamedQuery('vaultV2', 'get-document-variant', {
        variantId: document.variantId,
        includeUrl: true,
        contentDisposition: 'inline'
      })
    }
    return postNamedQuery('vaultV2', 'getDocument', {
      documentId: document.documentId,
      includeUrl: true,
      contentDisposition: 'inline'
    })
  }

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.vaultDocuments, 'documentPreview', document.documentId ?? document.variantId],
    queryFn: () => {
      return getDocumentUrl()
    },
    select: (res) => res.data
  })

  return (
    <div className={classes.previewBlock}>
      {isLoading && 'Loading preview...'}
      {!isLoading && data && (
        <div className={clsx(classes.previewIframeContainer, fullscreen && 'fullscreen')}>
          <div className={classes.previewBackdrop} />
          <iframe
            title='Document Preview'
            src={data.url}
            className={classes.previewIframe}
            frameBorder='0'
            allowFullScreen
            sandbox='allow-same-origin allow-scripts allow-popups allow-forms'
          />
          <SydButton onClick={() => setFullScreen(!fullscreen)} className={classes.previewFullscreenToggle}>
            {fullscreen ? 'Exit Fullscreen' : 'View Fullscreen'}
          </SydButton>
        </div>
      )}
    </div>
  )
}

DocumentDetailPreviewBlock.propTypes = {
  document: PropTypes.objectOf({
    documentId: PropTypes.string,
    variantId: PropTypes.string
  })
}
